export const formId = "refund-charge_form";
export const localeStringRoot =
  "settings.paywalls_admin_dashboard.charges.refund_modal";
